module.exports = __webpack_public_path__ + "img/right-leg.33363cb3.png";